import callAPiBase from './base';

const tagsLinesChartApi = {
  get: ({ startDate, endDate, type }: { startDate: number, endDate: number, type: number }) =>
    callAPiBase({
      endpoint: `/api/reports/tags?startDate=${startDate}&endDate=${endDate}&type=${type}`,
      method: 'GET',
      useToken: true,
    }),
};

export { tagsLinesChartApi };
export default tagsLinesChartApi;
